import { render } from "./SuccessModal.vue?vue&type=template&id=260c1f61&ts=true"
import script from "./SuccessModal.vue?vue&type=script&lang=ts"
export * from "./SuccessModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__